import { __read } from "tslib";
import { useEffect, useState } from 'react';
// Note: This function assumes that the observable that is passed is available and will not change
export function useObservableWithCallback(observable, callback) {
    var _a = __read(useState(null), 2), observableToUse = _a[0], setObservableToUse = _a[1];
    useEffect(function () {
        var subscription = observable.subscribe(function (value) {
            setObservableToUse(value);
            callback && callback(value);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [callback, observable]);
    return observableToUse;
}
//# sourceMappingURL=useObservableWithCallback.js.map